<template>
  <v-menu offset-y rounded bottom left>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon small>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item v-show="hasFile" @click="openInvoice">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-eye-outline </v-icon>
        <v-list-item-title>
          {{ $t('hausefulInvoices.actions.show') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-show="hasTransfer" @click="openTransfer">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-transfer </v-icon>
        <v-list-item-title>
          {{ $t('hausefulInvoices.actions.showTransfer') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-show="showRetryTransferLink" @click="retryTransfer">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-reload </v-icon>
        <v-list-item-title>
          {{ $t('hausefulInvoices.actions.retryTransfer') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-show="showApproveLink" @click="approveInvoice">
        <v-icon class="mr-3 green--text text--lighten-1" small left> mdi-check </v-icon>
        <v-list-item-title>
          {{ $t('hausefulInvoices.actions.approve') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-show="showRefuseLink" @click="refuseInvoice">
        <v-icon class="mr-3 warning--text text--lighten-1" small left> mdi-close </v-icon>
        <v-list-item-title>
          {{ $t('hausefulInvoices.actions.refuse') }}
        </v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item @click="excludeInvoice">
        <v-icon class="mr-3 red--text text--lighten-2" small left> mdi-trash-can-outline </v-icon>
        <v-list-item-title class="red--text">
          {{ $t('hausefulInvoices.actions.exclude') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { userHasSomeRole } from '@/util/helpers'

export default {
  name: 'AdminInvoiceTableMenu',

  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasFile() {
      return !!this.invoice?.file_response?.url
    },

    hasTransfer() {
      return !!this.invoice?.transfer
    },

    showApproveLink() {
      return this.invoice?.status !== 'APPROVED'
    },

    showRefuseLink() {
      return this.invoice?.status !== 'REFUSED'
    },

    transferHasFailed() {
      return this.invoice?.transfer?.status === 'FAILED'
    },

    showRetryTransferLink() {
      return this.transferHasFailed && !userHasSomeRole(['ROLE_PARTNER'])
    },
  },

  methods: {
    ...mapActions(['openModal']),
    ...mapMutations(['setAdminInvoice', 'setApproveInvoice']),

    openInvoice() {
      const url = this.invoice?.file_response?.url
      window.open(url, '_blank')
    },

    openTransfer() {
      const transferId = this.invoice?.transfer?.id
      window.open(`/transfer/${transferId}`, '_blank')
    },

    approveInvoice() {
      this.openModal('APPROVE_REFUSE_INVOICE_MODAL')
      this.setAdminInvoice(this.invoice)
      this.setApproveInvoice(true)
    },

    refuseInvoice() {
      this.openModal('APPROVE_REFUSE_INVOICE_MODAL')
      this.setAdminInvoice(this.invoice)
      this.setApproveInvoice(false)
    },

    excludeInvoice() {
      this.openModal('REMOVE_INVOICE_MODAL')
      this.setAdminInvoice(this.invoice)
    },

    retryTransfer() {
      const transfer = this.invoice?.transfer
      this.$emit('retryTransfer', transfer)
    }
  },
}
</script>
